/* @generated */
import * as React from "react";
import { boxStyles } from "./box.css.esm.js";
import { atoms } from "../config/atoms.css.esm.js";
import cx from "classnames";
import { polymorphicForwardRef } from "../config/types.esm.js";
function extractAtomsFromProps(props, atomsFn) {
  const atomProps = {};
  const otherProps = {};
  for (const key in props) {
    if (atomsFn.properties.has(key)) {
      atomProps[key] = props[key];
    } else {
      otherProps[key] = props[key];
    }
  }
  return { atomProps, otherProps };
}
const defaultElement = "div";
const Box = polymorphicForwardRef(
  ({ children, className, as, ...rest }, ref) => {
    const tagName = "tagName" in rest ? rest.tagName : void 0;
    const { atomProps, otherProps } = extractAtomsFromProps(rest, atoms);
    const cls = cx(atoms({ ...atomProps }), boxStyles, className);
    const Component = as || tagName || defaultElement;
    if (as === void 0) {
      delete otherProps.tagName;
    }
    return /* @__PURE__ */ React.createElement(Component, { ...otherProps, className: cls, ref }, children);
  }
);
Box.displayName = "Box";
export {
  Box,
  defaultElement
};
